module.exports = "<h1 mat-dialog-title>{{to.label || 'Rich editor'}}</h1>\n<div mat-dialog-content>\n\t<ckeditor [(ngModel)]=\"text\" debounce=\"500\" [config]=\"to.config\"></ckeditor>\n</div>\n\n<div mat-dialog-actions>\n\t<button mat-button (click)=\"cancel()\">CANCEL</button>\n\t<button mat-raised-button (click)=\"ok()\" color=\"primary\">OK</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/common/formly/types/rich-text-editor/ckeditor.dialog.html
// module id = ../../../../../src/app/common/formly/types/rich-text-editor/ckeditor.dialog.html
// module chunks = main